import styled from "styled-components"
import { breakpoint } from "../../utils/breakpoint"

export const StyledDetailHeader = styled.div`
  font-family: "Lato", georgia, serif;
  font-style: normal;
  font-weight: 800;
  font-size: 2em;
  line-height: 1;
  /* line-height: 80%; */

  text-transform: uppercase;

  color: #0f6494;

  ${breakpoint.md} {
    font-size: 1.8em;
  }
  ${breakpoint.lg} {
    font-size: 1.3em;
  }
`

export const StyledDetailLocation = styled.div`
  font-family: "Lato", georgia, serif;
  font-style: normal;
  font-weight: 500;
  font-size: 1.1em;
  /* line-height: 30px; */
  /* or 71% */

  color: #414042;

  border-bottom: 2px solid #0f6494;
  padding-bottom: 10px;

  ${breakpoint.md} {
    font-size: 1.2em;
  }

  ${breakpoint.lg} {
    border-bottom: 3px solid #0f6494;
    font-size: 1.2em;
  }
`

export const StyledDetailSubheader = styled.div`
  font-family: "Lato", georgia, serif;
  font-style: normal;
  font-weight: bold;
  font-size: 1.3em;
  /* line-height: 30px; */
  /* or 71% */

  color: #0f6494;

  ${breakpoint.md} {
    font-size: 1.35em;
  }

  ${breakpoint.lg} {
    font-size: 1.4em;
  }
`

export const StyledDetailSubheaderContent = styled.div`
  font-family: "Lato", georgia, serif;
  font-style: normal;
  font-weight: 500;
  font-size: 1.1em;
  /* line-height: 46px; */
  /* or 110% */

  color: #3b3f43;

  ${breakpoint.md} {
    font-size: 1.25em;
  }

  ${breakpoint.lg} {
    font-size: 1.4em;
  }
`
